import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Parceiros from "@/pages/Parceiros";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/parceiros" replace />} />
          <Route path="/parceiros" element={<Parceiros />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/parceiros" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
